import { createRouter, createWebHistory } from "vue-router";
import ErrorComponent from "@/components/ErrorComponent.vue";
import PolitiqueCookies from "../views/PolitiqueCookies.vue";
import PolitiqueConfidentialite from "../views/PolitiqueConfidentialite.vue";
import MentionsLegales from "@/views/MentionsLegales.vue";
import ConditionsGenerales from "@/views/ConditionsGenerales.vue";
import NonAutorise from "@/views/NonAutorise.vue";
import ConversationEnergie from "@/views/ConversationEnergie.vue";

const MARKETING_QUERY_TO_STORAGE_KEY = {
  utm_source: "utm_source",
  utm_medium: "utm_medium",
  utm_campaign: "utm_campaign",
  utm_content: "utm_content",
  utm_term: "utm_term",
  ad_id: "ad_id",
  camp_id: "ad_camp_id",
  adset_id: "ad_adset_id",
};

const getQueryValue = (value) => Array.isArray(value) ? value[0] : value;

const saveMarketingParams = (query) => {
  const existingParams = JSON.parse(localStorage.getItem("marketingParams") || "{}");
  const nextParams = { ...existingParams };

  Object.entries(MARKETING_QUERY_TO_STORAGE_KEY).forEach(([queryKey, storageKey]) => {
    const value = getQueryValue(query[queryKey]);

    if (typeof value === "string" && value.trim() !== "") {
      nextParams[storageKey] = value;
    }
  });

  localStorage.setItem("marketingParams", JSON.stringify(nextParams));
};



const router = createRouter({
  history: createWebHistory(), //
  routes: [
    {
      path: "/:catchAll(.*)",
      name: "404",
      meta: {
        title: "404",
      },
      component: ErrorComponent,
    },
    {
      path: "/nonautorise",
      name: "nonautorise",
      meta: {
        title: "non autorisé",
        requiresAuth: true
      },
      component: NonAutorise,
    }, 
    {
      path: '/',
      name: 'energie',
      meta: {
        title: "Bot-Energie",
        requiresAuth: false
      },
      component: ConversationEnergie,
      props: true
    },
    {
      path: "/:flag",
      name: "energieWithFlag",
      meta: {
        title: "Bot-Energie",
        requiresAuth: false,
      },
      component: ConversationEnergie,
      props: (route) => ({
        flag: route.params.flag,
      }),
    },
    {
      path: "/politiqueConfidentialite",
      name: "politiqueConfidentialite",
      meta: {
        title: "politique-confidentialité",
        requiresAuth: false
      },
      component: PolitiqueConfidentialite,
    },
    {
      path: "/politiquegestioncookies",
      name: "politiquegestioncookies",
      meta: {
        title: "politique-gestion-cookies",
        requiresAuth: false
      },
      component: PolitiqueCookies,
    },

    {
      path: '/mentionslegales',
      name: 'mentionslegales',
      meta: {
        title: "Mentions légales",
      },
      component: MentionsLegales,
      props: true
    },
    {
      path: '/conditionsgenerales',
      name: 'conditionsgenerales',
      meta: {
        title: "Conditions Générales d'utilisations",
      },
      component: ConditionsGenerales,
      props: true
    },
  ],
  transition: {
    name: "fade",
    mode: "out-in",
  },
  strict: true,
});

router.beforeEach(async (to, from, next) => {
  saveMarketingParams(to.query);

  if (to.params.flag) {
    localStorage.setItem('IPSMS', to.params.flag)
    next({ name: "energie", query: to.query });
  } else {
    next();
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;

